import tinycolor2 from 'tinycolor2';
import { StyleConstant } from 'util/getStyleConstant';

export function CEB_COLOR_SASS_CONST(sassColorConstantName) {
  return StyleConstant[`COLOR_${sassColorConstantName}`];
}

export function CEB_COLOR(str) {
  if (CEB_COLOR_SASS_CONST(str)) return tinycolor2(CEB_COLOR_SASS_CONST(str));
  if (str) return tinycolor2(str);
}

export function CEB_COLOR_RGBA(str, alpha = 1) {
  return CEB_COLOR(str)
    .setAlpha(alpha)
    .toRgbString();
}
